<template>
  <div class="">
    <div class="row">
      <h3 class="col-12">مقادیر پایه</h3>
      <div class="col">
        <label>قیمت پایه</label>
        <input type="number" pattern="\d+" v-model="reservationRule.base.price" class="form-control">
      </div>
      <div class="col">
        <label>تخفیف پایه</label>
        <input type="number" pattern="\d+" v-model="reservationRule.base.offer" class="form-control">
      </div>
    </div>

    <slot name="p-1"></slot>




  </div>
</template>

<script>
import CheckInOutManager from "../day/CheckInOutManager.vue";

export default {
  name: "ConfigInput",
  components: {CheckInOutManager},
  props: {
    reservation: {},
  },
  computed: {
    reservationRule() {
      return this.reservation.reservationRule
    }
  },


}
</script>

<style scoped>

</style>